import * as React from 'react';
import { Label as LabelPrimitive } from 'radix-ui';

import { cn } from '@/lib/utils';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      // §6: field label 12.5 muted, sitting 6–7px above its control.
      className={cn(
        'flex items-center gap-2 text-label select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:text-disabled peer-disabled:cursor-not-allowed peer-disabled:text-disabled',
        className,
      )}
      {...props}
    />
  );
}

export { Label };
